module.exports = __webpack_public_path__ + "@/assets/img/logo_original.19df8e79.png";